import React from 'react';
import { Flex, xcss } from '@atlaskit/primitives';
import AiAgentIcon from '@atlaskit/icon/core/ai-agent';
import { ModalEntryPointDropdownItemTrigger } from '@atlassian/jira-modal-entry-point-dropdown-item-trigger/src/ModalEntryPointDropdownItemTrigger.tsx';
import { fireUIAnalytics, useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import { useIntl } from '@atlassian/jira-intl';

import { browseTemplateModalEntryPoint } from './entrypoint.tsx';
import messages from './messages.tsx';

export const BrowseTemplateModalDropdownItem = () => {
	const { formatMessage } = useIntl();
	const { createAnalyticsEvent } = useAnalyticsEvents();

	return (
		<ModalEntryPointDropdownItemTrigger
			entryPoint={browseTemplateModalEntryPoint}
			entryPointProps={{}}
			interactionName="browse-agent-template-open-modal-button"
			useInternalModal={false}
			onClick={() => {
				fireUIAnalytics(
					createAnalyticsEvent({}),
					'button clicked',
					'moreRovodevAgentsButtonClicked',
				);
			}}
			// Moved inside after test is written
			// eslint-disable-next-line jira/integration/test-id-by-folder-structure
			testId="autodev-agent-picker.ui.picker-content.more-agents-button"
		>
			<Flex alignItems="center" xcss={buttonStyles}>
				<Flex xcss={iconWrapperStyles} alignItems="center" justifyContent="center">
					<AiAgentIcon label={formatMessage(messages.runAiCodingToolButtonLabel)} />
				</Flex>
				{formatMessage(messages.browseAllAgentsButtonLabel)}
			</Flex>
		</ModalEntryPointDropdownItemTrigger>
	);
};

const buttonStyles = xcss({
	paddingTop: 'space.100',
	paddingBottom: 'space.100',
});

const iconWrapperStyles = xcss({
	width: '16px',
	marginRight: 'space.250',
});
